import { Result } from "antd";

const PermissionDenied = ()=>{
    return <div>
        <Result status='error' 
        title="شما اجازه دسترسی به این صفحه را ندارید."
        subTitle="اجازه دسترسی شما به این صفحه توسط ادمین بسته شده است." />

    </div>
}
export default PermissionDenied;